
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  getPiCombinedUnit,
  getSupplierProduct,
  putPiCombinedUnit
} from "@/api/proforma";
import { deepClone } from "@/utils/deepClone";

@Component({
  name: "ModifyDiscounts"
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "强制核销" }) private title: "";
  @Prop({ default: {} }) private selectedItem: {};

  @Watch("show", { immediate: true })
  private async watchData() {
    if ((this.selectedItem as any).id && this.show) {
      this.form = deepClone(this.selectedItem);
    }
  }

  private form = {} as any;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[]
  };
  public tableCol = [
    {
      label: "S/N",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "HQ交易号码",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "询价参照号",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "参照号类型",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "交货进度",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    }
  ];
  private list = [
    {
      label: "核销金额",
      prop: "paymentMethod",
      key: "paymentMethod",
      type: "input",
      placeholder: "索赔金额",
      clearable: true,
      maxlength: 10,
      rules: {
        required: true,
        message: "请选择付款方式",
        trigger: "blur"
      },
    },
    {
      label: "核销原因",
      prop: "paymentRemark",
      key: "paymentRemark",
      type: "textarea",
      placeholder: "请输入核销原因",
      clearable: true,
      maxlength: 50
    },
  ];
  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }

  private async submitForm(): Promise<void> {
    this.putPiCombinedUnit();
  }

  private onSelectionChange(rows: any[]) {
    console.log(rows);
  }

  public async handleDelete(scope) {
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000
    });
  }


  // 更新组合单位
  private async putPiCombinedUnit() {
    const {
      hqProductName,
      supplier,
      shipmentQuantity,
      deliveryQuantity,
      deliveryChineseUnit,
      shipmentChineseUnit,
      deliveryEnglishUnit,
      shipmentEnglishUnit
    } = this.form;
    let params = {
      hqProductName,
      supplierAbbr: supplier,
      shipmentQuantity,
      deliveryQuantity,
      deliveryChineseUnit,
      shipmentChineseUnit,
      deliveryEnglishUnit,
      shipmentEnglishUnit
    };
    try {
      await putPiCombinedUnit(this.form.id, params);
      this.$notify({
        title: "成功",
        message: "创建成功",
        type: "success",
        duration: 2000
      });
      this.close();
      this.$emit("success", false);
    } catch {
    }
  }

  private async getPiCombinedUnit() {
    const res: any = await getPiCombinedUnit(this.form.id);
    this.getSupplierProduct(res.supplierId);
  }

  private async getSupplierProduct(supplierId) {
    const res: any = await getSupplierProduct(supplierId, {
      hqProductName: this.form.hqProductName
    });
    this.$set(this.form, "shipmentChineseUnit", res.chineseUnit || "");
    this.$set(this.form, "shipmentEnglishUnit", res.englishUnit || "");
    this.$set(this.form, "shipmentQuantity", 1);
    this.$set(this.form, "deliveryQuantity", 1);
  }
}
